<template>
  <div class="popUpWrap">
    <div class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="icon monitorCheck"></div>
        <h5>{{ t("skillCertify-caution-multiple-monitor-title") }}</h5>
        <p v-html="convertToNextLine(t('skillCertify-caution-multiple-monitor-description'))" />
        <div v-if="!isMultiMonitor" class="boxArea">
          <span class="ic"></span>{{ t('skillCertify-caution-multiple-monitor-enable') }}
        </div>
        <div v-if="isMultiMonitor" class="boxArea">
          <span class="ic none"></span>{{ t('skillCertify-caution-multiple-monitor-disable-1') }}<br>{{ t('skillCertify-caution-multiple-monitor-disable-2') }}
        </div>
        <div class="btnArea">
          <button :class="{ disabled: isMultiMonitor }" @click.stop="onClickAgree">
            {{ t("common-confirm") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {convertToNextLine, ref, useRouter} from '#imports';
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";
import DialogType from "~/components/Common/Dialog/model/DialogType";
import { ContestListModel } from "~~/package/mapper/contest/model/ContestListModel";
import { useContestService } from "~/composables/service/useContestService";
import { RecorderDomainType } from "~~/package/mapper/recorder/model/RecorderDomainType";
import {
  ProSkillAssureAssessmentMyInfoModel
} from "~~/package/mapper/proSkillAssure/model/assessment/myInfo/ProSkillAssureAssessmentMyInfoModel";

const { t } = useI18n();
const { $i18n } = useNuxtApp();
const dialogStore = useDialogStore();
const router = useRouter();
const { getContestReceive } = useContestService();

const contestData = ref<ContestListModel>(dialogStore.options.props.contest ?? new ContestListModel());
const domainType = ref<RecorderDomainType>(dialogStore.options.props.domainType);
const assessmentInfo = ref<ProSkillAssureAssessmentMyInfoModel>(dialogStore.options.props.assessmentInfo ?? new ProSkillAssureAssessmentMyInfoModel());
const callBack = ref<() => void>(dialogStore.options.props.callBack);

const isMultiMonitor = ref(false);
const multiMonitorIntervalId = ref<number | NodeJS.Timeout>(0)

onMounted(() => {
  isMultiMonitor.value = window.screen.isExtended as boolean
  multiMonitorIntervalId.value = setInterval(() => {
    isMultiMonitor.value = window.screen.isExtended as boolean
  }, 1000)
})

const handleContest = () => {
  if (contestData.value.useScreenRecording) {
    dialogStore.open({
      type: DialogType.CheatingScreenRecordingAgree,
      props: {
        contest: contestData.value,
        domainType: domainType.value
      }
    });
  } else {
    getContestReceive(contestData.value.id, 1).then(isAgree => {
      if (isAgree) {
        router.push({ path: `/contest/${contestData.value.id}/0` });
      }
    });
  }
};

const handleProSkillAssure = () => {
  if (assessmentInfo.value.isScreenRecordingFlag) {
    dialogStore.open({
      type: DialogType.CheatingScreenRecordingAgree,
      props: {
        assessmentInfo: assessmentInfo.value,
        domainType: domainType.value,
        callBack: callBack.value
      }
    });
  } else {
    callBack.value();
  }
};

// ASMT-PROCTOR-06, ASMT-PROCTOR-12: 진입 시 모니터 확인 — 확장 디스플레이 연결 중이면 Confirm 차단
const onClickAgree = () => {
  if (isMultiMonitor.value) return;

  if (domainType.value === RecorderDomainType.CONTEST) {
    handleContest();
  } else if (domainType.value === RecorderDomainType.PRO_SKILL_ASSURE) {
    handleProSkillAssure();
  }
};

const onClickClose = () => {
  clearInterval(multiMonitorIntervalId.value)
  dialogStore.close();
};
</script>

